module.exports = __webpack_public_path__ + "img/melissa-recibos.f86a6f18.png";